// extracted by mini-css-extract-plugin
export var border = "hero-module--border--0521b";
export var content = "hero-module--content--aa3a2";
export var fade = "hero-module--fade--fcb4c";
export var hasBorder = "hero-module--hasBorder--2b436";
export var wrapper = "hero-module--wrapper--86ab9";